import React, { useState, } from 'react';

import {
    Tabs,
    Tab,
    TabBody,
    Window,
    WindowHeader,
    WindowContent
  } from 'react95';
 
import { FirstAbout } from '../components/About/FirstAbout'
import { SecondAbout } from '../components/About/SecondAbout'
import { Tech } from '../components/About/Tech'


export const About = () => {
    const [state, setState] = useState({
      activeTab: 0
    });
    
    const handleChange = (e, value) => setState({ activeTab: value });
    
    const { activeTab } = state;
    return (
      <Window style={{ maxWidth: "800px" }}>
        <WindowHeader>
          about.exe
        </WindowHeader>
        <WindowContent>
          <Tabs value={activeTab} onChange={handleChange}>
            <Tab value={0}>About</Tab>
            <Tab value={1}>Priv</Tab>
            <Tab value={2}>Skils</Tab>
          </Tabs>
          <TabBody style={{ height: "auto" }}>
            {activeTab === 0 && (
              <FirstAbout/>
            )}
            {activeTab === 1 && (
              <SecondAbout/>
            )}
            {activeTab === 2 && (
              <Tech/>
            )}
          </TabBody>
        </WindowContent>
      </Window>
    );
    }